import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-request-sent',
    templateUrl: './request-sent.component.html',
    styleUrls: ['./request-sent.component.scss'],
})
export class RequestSentComponent {
    @Input() requestCategory: string;

    @Input() requestSubcategory: string;

    @Input() requestId: string;

    @Output() close = new EventEmitter<void>();

    onClose(): void {
        this.close.emit();
    }
}
